import { useOnDisconnect } from '@puzzlehq/sdk';
import { Outlet, createRootRoute, useNavigate } from '@tanstack/react-router';
import { Route as IndexRoute } from './index';
import 'ui_2/src/index.css';

export const Route = createRootRoute({
  component: function Component() {
    const navigate = useNavigate();

    useOnDisconnect(() => {
      navigate({ to: IndexRoute.to });
    }, []);

    return (
      <div className='fixed h-full w-full'>
        <Outlet />
      </div>
    );
  },
});
